"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hash;

var _objectHash = _interopRequireDefault(require("object-hash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

const options = {
  algorithm: 'sha1',
  respectType: false,
  unorderedObjects: true,
  unorderedArrays: false,
  unorderedSets: false
};

function hash(obj) {
  return (0, _objectHash.default)(obj, options);
}